import { colors } from "../../../style";

const style = {
  box: {
    background: "#2b2c40",
    border: `1px solid ${colors.border}`,
    borderRadius: "8px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.35)",
    padding: "10px 12px",
    minWidth: "140px",
    fontSize: "12.5px",
  },
  title: {
    color: colors.textStrong,
    fontWeight: 600,
    marginBottom: "6px",
  },
  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    color: colors.textMuted,
    lineHeight: "20px",
  },
  swatch: {
    display: "inline-block",
    width: "8px",
    height: "8px",
    borderRadius: "2px",
    marginRight: "6px",
  },
  value: {
    color: colors.text,
    fontVariantNumeric: "tabular-nums",
  },
};

/**
 * Recharts custom tooltip. `rows` maps the active payload to
 * [{ label, value, color }] so each chart controls its own wording.
 */
function ChartTooltip({ active, payload, label, title, rows }) {
  if (!active || !payload?.length) return null;

  const items = rows
    ? rows(payload)
    : payload.map((p) => ({ label: p.name, value: p.value, color: p.color }));

  return (
    <div style={style.box}>
      <div style={style.title}>{title ? title(label, payload) : label}</div>
      {items.map((item) => (
        <div key={item.label} style={style.row}>
          <span>
            {item.color && (
              <span style={{ ...style.swatch, background: item.color }} />
            )}
            {item.label}
          </span>
          <span style={style.value}>{item.value}</span>
        </div>
      ))}
    </div>
  );
}

export default ChartTooltip;
